import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "group relative inline-flex" };
const _hoisted_2 = ["aria-describedby"];
const _hoisted_3 = ["id"];
import { InformationCircleIcon } from '@heroicons/vue/outline';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'amendment-type-icon',
    props: {
        shortId: {},
        amendmentTypes: {}
    },
    setup(__props) {
        const props = __props;
        const DISPLAY_LABELS = {
            'Ad-Hoc': 'Type of IT account',
        };
        const tooltipId = computed(() => `amendment-type-${props.shortId}`);
        const label = computed(() => props.amendmentTypes
            .map((type) => DISPLAY_LABELS[type] ?? type)
            .join(', '));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createElementVNode("button", {
                    type: "button",
                    class: "inline-flex items-center text-blue-400 cursor-help rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400",
                    "aria-label": "Amendment type",
                    "aria-describedby": tooltipId.value,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                }, [
                    _createVNode(_unref(InformationCircleIcon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                    })
                ], 8, _hoisted_2),
                _createTextVNode(),
                _createElementVNode("span", {
                    id: tooltipId.value,
                    role: "tooltip",
                    class: "pointer-events-none absolute bottom-full left-1/2 z-10 mb-1 w-max max-w-xs -translate-x-1/2 rounded bg-gray-900 px-2 py-1 text-left text-xs font-normal text-white opacity-0 shadow group-hover:opacity-100 group-focus-within:opacity-100"
                }, _toDisplayString(label.value), 9, _hoisted_3)
            ]));
        };
    }
});
